import makeEvents from "../../../../helpers/event-creator.js";
const APP_EVENTS = makeEvents([
    'signup-form-submitted'
]);
export default APP_EVENTS;
